import { ModalBody } from 'ui/modal';
import { spacing } from 'ui/theme';
import styled from 'styled-components';

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusQuarter};
`;
